export default __webpack_public_path__ + "static/media/AlexanderNnamani.34bc04fc.svg";